module.exports = __webpack_public_path__ + "img/1.da02a282.png";